import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IYearMonth } from '@/coreDomainsModule/date';
import { diContainer } from '@/coreContainer/container';
import { ExportInventoryExcelUseCase } from '../../useCases/ExportInventoryExcelUseCase';
import { OutputFormat, IExportInventoryResultData } from '../../domains/entities/InventoryTemplate';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { ref } from 'vue';

/** 出力言語 */
export type ExportLanguage = 'ja' | 'en';

/**
 * テンプレートページに渡すフィルター情報の共有状態
 */
interface InventoryTemplateFilterState {
  filterItems?: FilterContentItem[];
}

/** テンプレートページに渡すフィルター情報 */
const templateFilterState = ref<InventoryTemplateFilterState>({});

/**
 * テンプレートページに渡すフィルター情報を設定する
 * @param filterItems - フィルター項目の配列
 */
export const setTemplateFilterState = (filterItems?: FilterContentItem[]): void => {
  templateFilterState.value = { filterItems };
};

/**
 * テンプレートページに渡すフィルター情報を取得する
 */
export const getTemplateFilterState = (): InventoryTemplateFilterState => {
  return templateFilterState.value;
};

/**
 * テンプレートページに渡すフィルター情報をクリアする
 */
export const clearTemplateFilterState = (): void => {
  templateFilterState.value = {};
};

/**
 * テンプレートベースのExcelエクスポートリクエストのパラメータ
 */
export interface ExportInventoryExcelParams {
  /** 出力するマスタ項目のキー配列 */
  masterItems: string[];
  /** 出力するデータ項目のキー配列 */
  outputDataItems: string[];
  /** 開始年月 */
  startYearMonth: IYearMonth;
  /** 終了年月 */
  endYearMonth: IYearMonth;
  /** 出力形式 */
  outputFormat: OutputFormat;
  /** 単一フィールド項目の挿入位置（キー: 項目キー、値: 月別ヘッダー内のインデックス） */
  singleFieldPositions?: { [key: string]: number };
  /** 出力言語（デフォルト: ja） */
  language?: ExportLanguage;
  /** フィルター項目の配列 */
  filterItems?: FilterContentItem[];
}

/**
 * テンプレートベースのExcelエクスポート処理
 * ExportInventoryExcelUseCaseを呼び出す
 * @param params - エクスポートパラメータ
 */
export const exportInventoryExcel = async (
  params: ExportInventoryExcelParams
): Promise<INetworkResult<IExportInventoryResultData, IError>> => {
  return await diContainer.exportInventoryExcelUseCase.execute(
    params.masterItems,
    params.outputDataItems,
    { year: params.startYearMonth.year, month: params.startYearMonth.month },
    { year: params.endYearMonth.year, month: params.endYearMonth.month },
    params.outputFormat,
    params.singleFieldPositions,
    params.language,
    params.filterItems
  );
};

/**
 * S3の署名付きURLからExcelファイルをダウンロードする
 * ExportInventoryExcelUseCaseのdownloadExcelを呼び出す
 * @param downloadUrl - S3からのダウンロード用署名付きURL
 * @param fileName - ダウンロードするファイル名
 */
export const downloadExcelFromUrl = (downloadUrl: string, fileName: string): void => {
  ExportInventoryExcelUseCase.downloadExcel(downloadUrl, fileName);
};
